export enum ProgramId {
  PROD = 'edp',
  UAT = 'gold',
  UAT_GTM = 'KMCCW2H',
  PROD_GTM = 'PDHNZCV',
}
